<template>
<div>
<b-modal id="modal-sm" size="md" title="Role Permission" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
  <div slot="default">
    <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
    <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
   </div> 
  <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
         <b-button variant="primary"  size="md"  class="float-right"  @click="roleExit"> Close </b-button>
     </div>
</b-modal>
<div  :hidden="hideOptions"> 

 <div class="form-group row  my-1">
    <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Set Role:</label>
    <div class="col-sm-4">
     <select  id="roles"  v-model="selectRole" v-on:change="RoleChange($event)"  class="form-control form-control-sm"> 
        <option v-for="option in Roles" v-bind:value="{id: option.roleid, text: option.role}" :key="option.roleid">
        {{ option.role }}
        </option> 
    </select> 
     </div>
    <!-- <div :class="{ 'col-sm-4 my-1': $v.selectRole.$error}"   v-show="$v.selectRole.$error">
       <div class="row">
        <small class="sml-red" v-if="!$v.selectRole.required">Select Role</small>
        </div> 
    </div> -->
  </div>

 <div class="form-group row  my-0">
    <label for="effDate" class="col-sm-4 col-form-label col-form-label-sm">Effective Date:</label>
    <div class="col-sm-4 my-0 ">
       <datepicker :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="effectiveDate" :format="dateFormat" id="effDate" :bootstrap-styling="true" :input-class="datapickClass" name="effectiveDatepicker"></datepicker> 
    </div>
    <div class="col-sm-4 my-0" :class="{ 'col-sm-4 my-0': $v.effectiveDate.$error}">
       <div class="row my-0">
        <small class="sml-red" v-if="!$v.effectiveDate.required">Effective date is required</small>
        </div> 
         <div class="row">
        <!-- <small class="sml-red" v-if="!$v.effectiveDate.minValue">Effective date can't be in the past</small> -->
            <!-- <small class="sml-red" v-if="!$v.effectiveDate.valid">Effective date is not valid.</small> -->
        </div> 
    </div>  
  </div>  
 
 
   <div class="form-group row  my-0">
    <label for="expDate" class="col-sm-4 col-form-label col-form-label-sm">Expiry Date:</label>
    <div class="col-sm-4 my-0">
      <datepicker   :open-date="new Date()" :disabledDates="{ to: new Date(Date.now() - 8640000) }" v-model="expiryDate" :format="dateFormat"  id="expDate"  :bootstrap-styling="true" :input-class="datapickClass">
      </datepicker> 
    </div>
    <div :class="{'col-sm-4 my-0': $v.expiryDate.$error}">
       <div class="row my-0">
        <small class="sml-red" v-if="!$v.expiryDate.required">Expiry Date date is required</small>
        </div> 
         <div class="row">
        <!-- <small class="sml-red" v-if="!$v.expiryDate.minValue">Expiry Date date can't be in the past</small> -->
        </div> 
    </div>
  </div>

  <div class="form-group row mb-0  my-0 py-0">
    <div class="col-sm-4 my-0 mb-0 py-0"><span class="col-sm-4 my-0 py-0 mb-0"></span></div> 
      <div class="col-sm-8 my-0 py-0 sml-red pl-3 mb-0">
         <template><RadioToggleButtons  v-model='expiryDate' :values='OpenEndedDate' color='#006537' textColor='#000' selectedTextColor='#fff' /><span v-on:click="expiryDate=''" style="font-size: 1em;"><i class="fas fa-times ml-2 pointer"></i>  </span> </template>
      </div> 
  </div>
  <div class="form-group row mb-0  my-0 py-0"> 
    <div class="col-sm-4 my-0 mb-0 py-0"><span class="col-sm-4 my-0 py-0 mb-0"></span></div> 
      <p class="col-sm-8 my-0 py-0 sml-red pl-3 mb-0" >Date Format: YYYY/MM/DD</p> 
  </div>
</div>  
<div class="alert alert-warning" role="alert" :hidden="!hideOptions">
       Sorry, you can't change your own role!
</div>

<hr>

    <div class="row" >
        <div class="col-sm-6" :hidden="hideOptions">
            <button v-on:click="updateRoles1" v-bind:disabled="disableSave" type="button" class="btn BtnSave btn-sml"><i :class="saveIcon"></i>{{saveBtnName}}</button>
        </div>
        <div class="col-sm-6">
            <button v-on:click="ClosePopup" type="button" class="btn btn BtnClose btn-sml float-right"> <i class="fas fa-times"></i>Close Form </button>
        </div>
    </div> 
</div> 

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import Vuelidate from 'vuelidate';
import moment from 'moment'
Vue.use(Vuelidate)

import {required,minValue} from 'vuelidate/lib/validators'

export default {
     props:{
        //  editUser:'',
        //  serviceId:'',
        //  roleId:'',
        //  Roles:[]
          UserData:'',
          action: ''
     },
    data: function () {
    return {
        OpenEndedDate: [
        { label: 'Open Ended Date', value: '9999/12/31' }], 
      saveIcon:'fas fa-plus',
      saveBtnName:'Edit Role',
      editUser:'',
       datapickClass:"form-control form-control-xs my-0",
         selectService: '',
        Services:[],
        selectRole: '',
        Roles:[],
      ActiveRole : [],
      UserCurrentData:'',
      dateFormat:'',
      effectiveDate:'',
      expiryDate:'',
      hideOptions:false,
      today:'',
      disableSave:true,
      succeeded:true,
      Msg:'',
      showModal:false,
      status:''

    }
},
   watch:{
     // if(this.UserCurrentData.RoleID == this.selectRole.id && this.UserCurrentData.EffectiveDate == this.effectiveDate && this.UserCurrentData.ExpiryDate == this.expiryDate)
      // selectRole:function(){
      //   if(this.selectRole.id != null && this.UserCurrentData.RoleID  != this.selectRole.ids)
      //   {
      //       //console.log('role here')
      //       this.disableSave = false;
      //   }        
      // },
      effectiveDate: function(){
        ////console.log('effectiveDate :'+ this.effectiveDate)
        if(this.effectiveDate != null && this.UserCurrentData.EffectiveDate != this.effectiveDate)
        {
          ////console.log('here')
            this.disableSave = false;
        }
      },
      expiryDate: function(){
         // //console.log('HSN:'+ this.HSN)
          if(this.expiryDate != null && this.UserCurrentData.ExpiryDate != this.expiryDate)
          {
              this.disableSave = false;
          }
      },
},
components:{
  Datepicker
},
methods:{
RoleChange(){
        if(this.selectRole.id != null && this.UserCurrentData.RoleID  != this.selectRole.id)
        {
            ////console.log('role here')
            this.disableSave = false;
        } 
        else if(this.UserCurrentData.RoleID  == this.selectRole.id)
        {
           ////console.log('chna here')
          this.disableSave = true;
        }
},
     showMsg(msg,data,Title) {
          this.boxTwo = ''
          this.$bvModal.msgBoxOk(msg, {
          title: Title,
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',          
          okTitle: 'Close', 
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            ////console.log('at value ' + value)
            this.boxTwo = value
            if(value)
            {
             
            }
          })
          .catch(err => {
            // An error occurred
          })
      },
       roleExit: function() { 
          this.showModal=false;    
        //this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        if(this.succeeded){
           this.$emit('roleUpated');
        }

    },
    changeExpiry(){
      
    },
     ClosePopup: function() {     
      this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow') 
    },
    CheckActiveRole()
    {
      //console.log(this.$v)
       this.$v.$touch();
      if (!this.$v.$invalid){
        //console.log('valid')
      var vm = this;
        axios.get('SaskHealthApi/security/GetIsActiveRole?_='+Date.now()+'&username='+vm.editUser, { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
        .then(function (response) {
          //console.log(response.data)
              vm.ActiveRole = response.data;
              vm.updateRoles();
              // if(response.data.roleID =vm.selectRole.id)
              // {
              //     vm.showMsg("There is already active role exist for this user, please terminate the role first.",'','User Role Message')
              // }
              // else
              // {

              //   //vm.updateRoles();
              // }
          })
      .catch(function (er) {
      //GetIsActiveRole
      });
      }
    },
    FillRole: function(){
      var vm = this;
            vm.Roles = [];

            var params = new URLSearchParams();
            
            params.append('ServiceID', this.UserData.serviceid);

             axios.get('/SaskHealthApi/Security/GetRolesByServiceID', { headers: { 'Authorization': 'Bearer ' + localStorage.access_token },params})
             //axios.get('/SaskHealthApi/Codes/GetRoles')
                .then(function (response) { 
              vm.Roles = response.data
           
                })
            .catch(function (er) {
                    //console.log(er)
            }).then(function () {
              var myrole = vm.Roles.find(x=>x.roleid === vm.UserData.roleid);
              
              var selected  = {
              id: myrole.roleid,
              text: myrole.role
              }; 
              vm.selectRole = selected;
                //vm.selectRole.id = vm.UserData.roleid;
                //vm.selectRole.text = vm.UserData.role;
               //vm.effectiveDate = moment(vm.UserData.effectivedate,"YYYY/MM/DD");//.format('YYYY/MM/DD'); 
               vm.effectiveDate = vm.UserData.effectivedate;
               vm.expiryDate = vm.UserData.expirydate;
               vm.UserCurrentData = {RoleID : myrole.roleid,EffectiveDate: vm.effectiveDate,ExpiryDate:vm.expiryDate}
                });  
    },
    validEffectDate()
    {
      //yyyy/MM/dd  YYYY-MM-DD
      //console.log('effect date : ' +this.effectiveDate)
      var effdate   = moment(this.effectiveDate).format('YYYY/MM/DD'); 
      var eff = moment(effdate,true);
      var isValid1 = eff.invalidAt(); 
      //var isValid = eff.isValid();
      //console.log(isValid1)
      //console.log('effect date after : ' +effdate)
      //console.log('valid  : ' +eff.isValid())
      return true;// isValid;
    },
    validateData(){ 
      ////console.log(this.UserCurrentData.RoleID)
      ////console.log(this.UserCurrentData.EffectiveDate)
      ////console.log(this.UserCurrentData.ExpiryDate)
      if(this.UserCurrentData.RoleID == this.selectRole.id && this.UserCurrentData.EffectiveDate == this.effectiveDate && this.UserCurrentData.ExpiryDate == this.expiryDate)
      {
         this.showMsg('No Changes were made');
      }
      else
      {
        this.updateRoles();
      }
    },
    updateRoles: function(){
         //console.log('here after');
         //console.log(this.$v)
      this.$v.$touch();
      if (!this.$v.$invalid){
   //console.log(this.$v)
        //this.disableSave = true;
        // if(((moment(this.expiryDate)).toISOString() >= moment(new Date("12/31/9998")).startOf('day').toISOString()))
        //   {
        //     this.expiryDate = moment(new Date("12/31/9999")).startOf('day');
        //   }
        //   else{
        //     this.expiryDate = moment(this.expiryDate).startOf('day');
        //   }
        //   this.effectiveDate = moment(this.effectiveDate).startOf('day');
          var vm = this;

          var url = "/SaskHealthApi/Security/PostUpdateRoles/"
            var params = {
                "_": Date.now(),
                "UserName": vm.editUser,
                "RoleID": vm.selectRole.id,
                "StartDate": vm.effectiveDate,
                "EndDate": vm.expiryDate,
                "Status":vm.UserData.status,
                "RecID" : vm.UserData.rolerecid
                } 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                  //console.log(response)
               
                          vm.succeeded = true;
                          vm.Msg="Role Successfully Saved For " +  vm.selectRole.text + ".";  
                          //vm.Msg="<div class='alert alert-warning' role='alert'>"+'Permission Not Saved Successfully Saved For ' +  vm.selectRole.text +"</div>";                                                  
                          vm.showModal=true; 
                })
                .catch(function (er) {
                     //vm.disableSave = false;
                     vm.succeeded = false;
                    //  vm.Msg="Warning: Role Not Successfully Saved For " +  vm.selectRole.text +".";  
                    //  vm.showModal=true;
                    
                    if(er.response.status === 400)
                      {
                        if(er.response.data.message !=null)
                        vm.showMsg(er.response.data.message,'','User Role Error');
                        else
                        vm.showMsg('Network Error, please contact system admin for more detail.','','User Role Edit');
                      }
                      else
                        vm.showMsg('Network Error, please contact system admin for more detail.','','User Role Edit');
                               
                    ////console.log(er)
                }).then(function () {
 
                });  
      }
    },

    updateRoles1: function(){
         //console.log('here after');
         //console.log(this.$v)
      this.$v.$touch();
      if (!this.$v.$invalid){
   //console.log(this.$v)
        //this.disableSave = true;
        // if(((moment(this.expiryDate)).toISOString() >= moment(new Date("12/31/9998")).startOf('day').toISOString()))
        //   {
        //     this.expiryDate = moment(new Date("12/31/9999")).startOf('day');
        //   }
        //   else{
        //     this.expiryDate = moment(this.expiryDate).startOf('day');
        //   }
        //   this.effectiveDate = moment(this.effectiveDate).startOf('day');
          var vm = this;

          var url = "/SaskHealthApi/Security/PostUpdateRoles/"
            var params = {
                "_": Date.now(),
                "UserName": vm.editUser,
                "RoleID": vm.selectRole.id,
                "StartDate": vm.effectiveDate,
                "EndDate": vm.expiryDate,
                "Status":vm.UserData.status,
                "RecID" : vm.UserData.rolerecid
                } 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                  //console.log(response)
               
                          vm.succeeded = true;
                          vm.Msg="Role Successfully Saved For " +  vm.selectRole.text + ".";  
                          //vm.Msg="<div class='alert alert-warning' role='alert'>"+'Permission Not Saved Successfully Saved For ' +  vm.selectRole.text +"</div>";                                                  
                          vm.showModal=true; 
                })
                .catch(function (er) {
                     //vm.disableSave = false;
                     vm.succeeded = false;
                    //  vm.Msg="Warning: Role Not Successfully Saved For " +  vm.selectRole.text +".";  
                    //  vm.showModal=true;
                    
                    if(er.response.status === 400)
                      {
                        if(er.data.message !=null)
                        vm.showMsg(er.data.message,'','User Role Error');
                        else
                        vm.showMsg('Network Error, please contact system admin for more detail.','','User Role Edit');
                      }
                      else
                        vm.showMsg('Network Error, please contact system admin for more detail.','','User Role Edit');
                               
                    ////console.log(er)
                }).then(function () {
 
                });  
      }
    },

},
created (){
  ////console.log(this.action)
  //console.log(this.UserData)
  if(this.action =="EDIT")
  {
      this.saveIcon = 'far fa-edit';
      this.saveBtnName ='Edit Role';
  }
  this.editUser =this.UserData.username;
  this.dateFormat = this.$store.getters.GetDateFormat;
  if(this.editUser == this.$store.getters.GetCurrentUser)
  this.hideOptions = true;
  this.FillRole(); 
},
validations(){
      return {
        effectiveDate:{
          required, 
         // isNumber: value=> this.validProvider(),
				//minValue: value => (moment(this.effectiveDate)).toISOString() >= moment(new Date()).startOf('day').toISOString()
        //valid: value=> this.validEffectDate(),
        },
        expiryDate:{
        required,

			//	minValue: value => (moment(this.expiryDate)).toISOString() >= moment(new Date()).startOf('day').toISOString()
      
        }
      }
}
}
</script>

<style scopped>
.form-control-xs {
    height: calc(1.7em + .350rem + 1px) !important;
    padding: .150rem .25rem !important;
    font-size: .75rem !important;
    line-height: 1.5;
    border-radius: .2rem;
}
.label-small {
  vertical-align: super;
  font-size: small;
}

.modal-header {
    
    padding: .25rem !important;
    align-content: center;
    text-align: center !important;
}
/* .modal-footer
{
  padding: .50rem !important;
} */
/* .form-group {
  margin-bottom: 0;
} */
</style>
